$('#image-text-slider').slick({
  infinite: true,
  slidesToShow: 1,
  autoplay: true,
  arrows: false,
  dots: true,
  slidesToScroll: 1
});

$('.collection-list__card-grid').slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

$(document).ready(function(){

  $('.product-information-popup > .product-information-tag').click(function(){
    $('.popup-wrapper').show();
  });
  $('.popup-wrapper .popup-overlay, .popup-topbar .close-btn').click(function(){
    $('.popup-wrapper').hide();
  });
});


$(document).on('click', '.drawer-menu-toggle', function() {
    setTimeout(function(){ 
      if( $(".drawer-menu__menu-item--large[data-page-id=DrawerMenuPage-bestsellers]").length ){
        var mob_a = `<a class="drawer-menu__menu-item drawer-menu__menu-item--large " href="/collections/new-arrivals" aria-label="New Arrivals"><span class="drawer-menu__menu-item-label">New Arrivals</span></a><a class="drawer-menu__menu-item drawer-menu__menu-item--large " href="/collections/bestsellers" aria-label="Bestsellers"><span class="drawer-menu__menu-item-label">Bestsellers</span></a>`;
        $(".drawer-menu__menu-item--large[data-page-id=DrawerMenuPage-bestsellers]").after(mob_a);
        $(".drawer-menu__menu-item--large[data-page-id=DrawerMenuPage-bestsellers]").remove();
        $(".drawer-menu__menu-item--large[data-page-id=DrawerMenuPage-new-arrivals]").remove();
      }
    }, 100);
});